// extracted by mini-css-extract-plugin
module.exports = {"base":"oranism-m__base__1qmF2","first-story":"oranism-m__first-story__3SD2b","rest-stories":"oranism-m__rest-stories__YoI_e"};